import { Controller } from '@hotwired/stimulus';

// Opens the browser's own print dialogue, where the page can be saved as PDF.
// Nothing is rendered server-side — what gets printed is what the print
// stylesheet makes of the page.
export default class extends Controller<HTMLElement> {
  print(): void {
    window.print();
  }
}
